import interfaceApi from '@/api/admin/interfaceApi'
import { RootState } from '@/store/stores'
import { initialState, SRCInterface } from '@/store/types/srcInterfaceType'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export const fetchInterfaceDetails = createAsyncThunk(
  'srcInterface/fetchInterfaceDetails',
  async (interfaceId: string, { rejectWithValue }) => {
    try {
      const { data } = await interfaceApi.getById(interfaceId)
      return data as SRCInterface
    } catch (error) {
      return rejectWithValue(error)
    }
  },
  {
    condition: (interfaceId, { getState }) => {
      const { srcInterface } = getState() as RootState
      // don’t re-dispatch if it’s already loading for this ID
      return !srcInterface.isLoadingInterfaceDetails
    },
  },
)

export const srcInterfaceSlice = createSlice({
  name: 'srcInterface',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchInterfaceDetails
      .addCase(fetchInterfaceDetails.pending, (state) => {
        state.isLoadingInterfaceDetails = true
      })
      .addCase(fetchInterfaceDetails.fulfilled, (state, action) => {
        state.isLoadingInterfaceDetails = false
        state.currentInterface = action.payload
      })
      .addCase(fetchInterfaceDetails.rejected, (state) => {
        state.isLoadingInterfaceDetails = false
      })
  },
})

export const srcInterfaceState = (state: RootState) => state.srcInterface

export default srcInterfaceSlice.reducer
